import classNames from "classnames";
import { ReactNode } from "react";
import { generalInnerSizeMaxWidthWrapper } from "../PageLayouts";
import { xPaddingClassNameMobile } from "./constants";

export function Container({
  children,
  fullWidth,
}: {
  children: ReactNode;
  fullWidth?: boolean;
}) {
  return (
    <div
      className={classNames(
        "relative mx-auto text-white",
        !fullWidth && generalInnerSizeMaxWidthWrapper
      )}
    >
      {children}
    </div>
  );
}

export type MobileToolbarStyle = "fixed" | "above";

export function Toolbar({
  children,
  mobileStyle,
}: {
  children: ReactNode;
  mobileStyle: MobileToolbarStyle;
}) {
  return (
    <menu
      className={classNames(
        "hide-scroll-bars flex h-20 items-center overflow-x-auto bg-black md:sticky md:top-0 md:mb-2 md:h-auto md:border-t-0 md:px-0",
        mobileStyle === "fixed"
          ? `fixed inset-auto inset-x-0 bottom-0 z-10 border-t border-t-slate-300 px-4 ${xPaddingClassNameMobile} py-2`
          : "pb-2",
        "md:px-0"
      )}
    >
      <div className={classNames(generalInnerSizeMaxWidthWrapper, "w-full")}>
        {children}
      </div>
    </menu>
  );
}

export function MobileFloatingToolbar({
  children,
  onClick,
  className,
  toolbarMobileStyle,
}: {
  children: ReactNode;
  onClick: () => void;
  className?: string;
  toolbarMobileStyle: MobileToolbarStyle;
}) {
  return (
    <button
      onClick={onClick}
      className={classNames(
        "fixed bottom-24 left-1/2 z-10 -translate-x-1/2 overflow-hidden rounded-full border-2 border-slate-300 bg-black p-2 py-3 text-white shadow-2xl transition-all md:hidden",
        toolbarMobileStyle === "fixed" ? "bottom-24" : "bottom-4",
        className
      )}
    >
      {children}
    </button>
  );
}
